export const WorkspaceTypePolicies = {
  Viewer: {
    fields: {
      cards: {
        merge(existing: any, incoming: any) {
          return incoming;
        },
      },
      cardTasks: {
        merge(existing: any, incoming: any) {
          return incoming;
        },
      },
    },
  },
  Workspace: {
    fields: {
      goalCards: {
        merge(existing: any, incoming: any) {
          return incoming;
        },
      },
      eventCards: {
        merge(existing: any, incoming: any) {
          return incoming;
        },
      },
    },
  },
  GoalCard: {
    fields: {
      linkedCards: {
        merge(existing: any, incoming: any) {
          return incoming;
        },
      },
    },
  },
  EventCard: {
    fields: {
      linkedCards: {
        merge(existing: any, incoming: any) {
          return incoming;
        },
      },
    },
  },
};
